export const loadFromCacheAction = ({ actionName, cachedData }) => ({
  type: actionName,
  payload: cachedData,
});
